import type { MultipleSelectQ } from "../../types/quiz";

export type MultipleSelectProps = {
  q: MultipleSelectQ;
  values: Set<number>;
  onToggle: (i: number) => void;
};

export function MultipleSelect({ q, values, onToggle }: MultipleSelectProps) {
  return (
    <div className="cq-grid cq-gap-4 md:cq-grid-cols-2">
      {q.options.map((o, i) => {
        const checked = values.has(i);
        const disabled = !checked && values.size >= q.max_selections;
        return (
          <label
            key={i}
            className={[
              "cq-flex cq-w-full cq-items-center cq-gap-3 cq-border-2 cq-p-3 sm:cq-p-4 !cq-border-solid",
              checked ? "cq-border-black cq-bg-black cq-text-white " : " cq-border-cfa-blue-500 cq-text-black ",
              disabled ? "cq-opacity-60" : "cq-cursor-pointer ",
            ].join(" ")}
          >
            <input
              type="checkbox"
              checked={checked}
              onChange={() => onToggle(i)}
              disabled={disabled}
              className="cq-w-6 cq-h-6 cq-accent-cfa-blue-500 cq-shrink-0"
            />
            <div>
                <div className="cq-normal cq-text-sm md:cq-text-lg md:cq-leading-6">{o.text}</div>
            </div>
          </label>
        );
      })}
    </div>
  );
}

export default MultipleSelect;
